// extracted by mini-css-extract-plugin
module.exports = {"header":"JurisprudenceModal_header__2_yqL","body":"JurisprudenceModal_body__3OMCV","title":"JurisprudenceModal_title__JBIVX"};